import {Box, IconButton, Stack, Typography} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {AnimatedLoader} from "./AnimatedLoader";

interface IFullscreenProcessingContentProps {
    onClose: () => void;
}

export const FullscreenProcessingContent = ({onClose}: IFullscreenProcessingContentProps) => {
    return (
        <Box
            sx={{
                position: 'relative',
                width: '80vw',
                height: '50vh',
                backgroundColor: 'rgba(0, 0, 0, 0.95)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: 'white',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    },
                }}
            >
                <CloseIcon />
            </IconButton>
            <Stack alignItems="center" spacing={2}>
                <AnimatedLoader size="150px" />
                <Typography variant="h6" sx={{color: 'white'}}>
                    Generating...
                </Typography>
            </Stack>
        </Box>
    );
};
